export const province = [
    {
        index: '-',
        Province: [
            '全部省份'
        ]
    },
    {
        index: 'A',
        Province: [
            '安徽省',
            '澳门特别行政区'
        ]
    },
    {
        index: 'B',
        Province: [
            '北京市'

        ]
    },
    {
        index: 'C',
        Province: [
            '重庆市'
        ]
    },
    {
        index: 'F',
        Province: [
            '福建省'
        ]
    },
    {
        index: 'G',
        Province: [
            '甘肃省',
            '广东省',
            '贵州省'
        ]
    },
    {
        index: 'H',
        Province: [
            '海南省',
            '河北省',
            '河南省',
            '黑龙江省',
            '湖北省',
            '湖南省'
        ]
    },
    {
        index: 'J',
        Province: [
            '吉林省',
            '江苏省',
            '江西省'
        ]
    },
    {
        index: 'L',
        Province: [
            '辽宁省'
        ]
    },
    {
        index: 'Q',
        Province: [
            '青海省'
        ]
    },
    {
        index: 'S',
        Province: [
            '山东省',
            '山西省',
            '陕西省',
            '上海市',
            '四川省'
        ]
    },
    {
        index: 'T',
        Province: [
            '台湾省',
            '天津市'
        ]
    },
    {
        index: 'X',
        Province: [
            '香港特别行政区'
        ]
    },
    {
        index: 'Y',
        Province: [
            '云南省'
        ]
    },
    {
        index: 'Z',
        Province: [
            '浙江省'
        ]
    },
]